import { useEffect } from 'react';

const usePageTitle = (title) => {
  useEffect(() => {
    document.title = title ? `${title} - CoAgenda` : 'CoAgenda - Agenda Colaborativa';
  }, [title]);
};

export default usePageTitle;
